module.exports = "//d274d294w9cx2v.cloudfront.net/f43cdba6e1c94587685bfa50566f72008df45457/images/venmoBadge.png";